/**
    首页默认内容
 */
<template>
  <div class="indexAll">
    <!-- 轮播图 -->
    <nav class="carousel">
      <el-carousel
        height="417px"
        arrow="never"
        v-if="bannerData">
        <el-carousel-item
          v-for="(item, index) in bannerData"
          :key="index">
          <div carContant>
            <el-image
              class="bcimg"
              :src="item.pic"/>
            <span>{{ item.pic }}</span>
          </div>
        </el-carousel-item>
      </el-carousel>
      <TypeSelectBox
        class="typeBox"
        :data="this.types"
        :typeSelect="this.typeSelect"/>
    </nav>
    <Adv class="advertisement"/>
  </div>
</template>

<script>
/**
 * 导入组件
 * IndexListSlot  插槽容器
 * ProductItem   单项渲染组件
 * CDItem     倒计时组件
 * CombItem  拼团组件
 */
import IndexListSlot from './components/indexSlot'
import ProductItem from './components/indexItem'
import CDItem from './components/countdownItem'
import CombItem from './components/combItem'
import NotFoundInfo from '@/components/NotFound/NotFoundInfo'
import TypeSelectBox from './components/typeSelectBox4'
import Adv from './adv/index.vue'
/**
 * 引入api
 */
import {
  getIndexPageList,
  getCanvasData,
  getCategory,
  getProducts
} from '@/api/indexpage.js'
import { cartCount } from '@/api/cart.js'
// import {
//   getbargainList
// } from '@/api/bargain.js'
// import {
//   cartAdd
// } from '@/api/cart.js'
import { seckillTime, seckillList } from '@/api/seckill.js'
// moc data
import { mocLayoutData, mocTypesData } from '@/mocData/indexAll.js'
import {mapMutations} from "vuex";
import { getToken } from '@/axios/cookies.js'

export default {
  components: {
    ProductItem,
    IndexListSlot,
    CDItem,
    CombItem,
    NotFoundInfo,
    TypeSelectBox,
    Adv
  },
  data () {
    return {
      productNew: {
        'header': {
          'title': '新品首发',
          'bcText': 'THE NEW START',
          'interface': '/indexpage/productlist'
        },
        'section': [{ 'image': '', 'storeName': '', 'otPrice': '' }]
      },
      productHot: {
        'header': {
          'title': '人气爆款',
          'bcText': 'POPULAR STYLE',
          'interface': '/indexpage/productlist'
        },
        'section': [
          { 'image': '', 'storeName': '', 'otPrice': '' }
        ]
      },
      productSeckill: {
        'header': {
          'title': '秒杀专区',
          'bcText': 'SECONDS KILL ZONE',
          'interface': '/indexpage/seckill'
        },
        'section': [
          // { 'image': '', 'storeName': '', 'otPrice': '' }
        ]
      },
      purdouctComb: {
        'header': {
          'title': '拼团专区',
          'bcText': 'SPELL GROUP ZONE',
          'interface': '/indexpage/combination'
        },
        'section': [
          { 'image': '', 'storeName': '', 'otPrice': '' }
        ]
      },
      pruductDiscount: {
        'header': {
          'title': '折扣专区',
          'bcText': 'DISCOUNT ZONE',
          'interface': ''
        },
        'section': [
          { 'image': '', 'storeName': '', 'otPrice': '' }
        ]
      },
      productBargin: {
        'header': {
          'title': '砍价专区',
          'bcText': 'BARGAINING ZONE',
          'interface': '/indexpage/productlist'
        },
        'section': [
          { 'image': '', 'storeName': '', 'otPrice': '' }
        ]
      },
      // bargain: [
      //   {'image': '', 'title': '', 'minPrice': '', 'price': ''},
      //   {'image': '', 'title': '', 'minPrice': '', 'price': ''},
      //   {'image': '', 'title': '', 'minPrice': '', 'price': ''}
      // ],
      // 轮播图展示
      bannerData: [],
      // 分类展示
      types: [],
      typeSelect: '',
      layoutData: [],
      loading: false,
      loading2: false,
      status: 1,  // 登陆状态
    }
  },
  created () {
    this.isLogin();
    // 若已登录，则请求购物车数量
    if(this.status) this.getCartNum();
    // this.getIndexData();
    this.getCanvas();
    this.getCateList();
  },
  methods: {
    ...mapMutations({
      setCartNum: 'SET_CARTNUM' // 修改vuex购物车数量
    }),
    // 判断是否已登录
    isLogin () {
      // 0未登录 1已登陆
      this.status = !getToken() ? 0 : 1;
      console.log('---isLogin: status---');
      console.log(this.status);
    },
    // 获取购物车商品数量
    async getCartNum () {
      let res = await cartCount();
      if (res.status === 200) {
        console.log('---indexAll cartNum---');
        console.log(res);
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getCanvas () {
      // let res = await getCanvasData({ terminal: '4' });
      // console.log(res);
      // this.layoutData = JSON.parse(res.json);
      //
      // if (Array.isArray(this.layoutData)) {
      //   this.layoutData = this.layoutData.map(item => {
      //     if (item.type === 'banner') {
      //       // this.bannerData = item.componentContent.bannerData || []
      //       this.bannerData = mocLayoutData[2].componentContent.bannerData || [];
      //     }
      //
      //     return item.type;
      //   })
      // } else {
      //   this.$message.error('返回数据有误，请检查返回的数据格式！')
      // }

      this.bannerData = mocLayoutData[2].componentContent.bannerData || [];
    },
    // 分类查询
    async getCateList () {
      let response = await getCategory();
      if (response.status === 200 && response.success) {
        let res = response.data;
        console.log('---indexpage getCateList res---');
        console.log(res);
        this.types = this.types.concat(
          res.map(item => {
            return {
              'value': `${item.id}`,
              'label': `${item.cateName}`,
              'children': item.children.map(i => {
                return {
                  value: i.id,
                  label: i.cateName,
                  pic: i.pic
                }
              })
            }
          })
          // res[0].children.map(item => {
          //   return {
          //     'value': `${item.id}`,
          //     'label': `${item.cateName}`,
          //     'children': []
          //   }
          // })
        );
        console.log(this.types);
        this.typeSelect = this.types[0].value;
      } else {
        this.$message.error(res.msg || '无分类信息！');
      }
    },
    showSelectPage () { },
    // 查询首页数据
    getIndexData () {
      this.loading = true
      getIndexPageList().then(res => {
        if (res.status === 200) {
          this.seletcVal(res.data)
          this.loading = false
          // 获取砍价数据
          // 统一获取其他内容
          // this.getSeckBarData([seckillTime(), getbargainList()])
          // this.getSeckBarData([seckillTime()])
        } else {
          console.log('getIndexData false');
          this.$message.error(res.msg)
        }
      })
    },
    // 获取首页接口没有的数据
    getSeckBarData (arr) {
      this.loading2 = true
      Promise.all(arr).then(res => {
        // 秒杀专区数据
        if (res[0].status === 200) {
          var seckNow = res[0].data.seckillTime.map(item => {
            if (item.status === 1) {
              return { 'id': item.id, 'time': item.time, 'stop': item.stop }
            }
          }).filter(r => r)
          if (seckNow[0]) {
            seckillList(seckNow[0].id, { 'limit': 10, 'page': 1 }).then(res => {
              this.productSeckill.section = this.filterRes(res.data, 4)
            })
          }
        }
        // // 砍价专区数据
        // if (res[1].status === 200) {
        //   this.bargain = this.filterRes(res[1].data, 3)
        //   console.log(this.bargain)
        // }
        this.loading2 = false
      })
    },
    // 数据筛选
    seletcVal (obj) {
      // console.log(obj)
      // 轮播图
      /**
       * author: @Karen
       * 无引用？
       */
      this.banner = obj.banner
      // 新品首发
      this.productNew.section = obj.firstList.map((item, index) => {
        if (index < 4) {
          return item
        }
      }).filter(r => r)
      // 人气爆款
      this.productHot.section = this.filterRes(obj.likeInfo, 4)
      // 拼团专区
      this.purdouctComb.section = this.filterRes(obj.combinationList, 6)
    },
    // 只留下固定数量的数据
    filterRes (arr, num) {
      return arr.map((item, index) => {
        if (index < num) {
          return item
        }
      }).filter(r => r)
    },
    // 详情跳转
    toDetail (id, type) {
      this.$router.push({
        path: '/productDetail',
        query: {
          productId: id,
          type: type
        }
      })
    }
    // 首页数据无sku 废弃toCart
    // toCart (id) {
    //   console.log(id)
    //     cartAdd({
    //         'bargainId': 0,
    //         'cartNum': 1,
    //         'combinationId': 0,
    //         'new': 0,
    //         'productId': id,
    //         'secKillId': 0,
    //         'uniqueId': ''
    //     }).then(res => {
    //         console.log(res)
    //         if (res.status === 200) {

    //         } else {
    //             this.$message.error(res.msg)
    //         }
    //     })
    // }
  }
}
</script>

<style scoped lang="scss">
.indexAll {
  width: 100%;
  /*max-width: 1720px;*/
  /*min-width: 1170px;*/
  .el-carousel__button {
    height: 2px;
    opacity: 1;
    background-color: #cccccc;
  }
  .is-active {
    .el-carousel__button {
      background-color: #333333;
    }
  }
  .carousel {
    /*轮播图宽度*/
    max-width: 1170px;
    margin: auto;
    position: relative;
    .typeBox {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      height: 100%;
    }
  }
  // 咨讯框
  .advertisement{
    width: 1170px;
    margin: auto;
    padding: 20px 0 20px 0;
  }
  .bcimg {
    width: 100%;
    height: 755px;
    float: left;
  }
  .indexContent {
    width: 1170px;
    margin: auto;
    padding-bottom: 70px;
    .blockItem {
      margin: 30px 0;
      .common {
        margin: 30px 0;
        display: flex;
        justify-content: space-between;
        .newPro {
          width: 278px;
        }
      }
      // 人气爆款 独有部分
      .hotItem {
        .left {
          width: 500px;
          height: 695px;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          .title {
            margin: 50px 0 0 50px;
            text-align: left;
            font-size: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .price {
            margin: 30px 50px;
            color: #333333;
            font-size: 22px;
            font-weight: 500;
            .putCart {
              float: right;
              cursor: pointer;
            }
          }
          .imgPro {
            width: 375px;
            height: 375px;
            margin: auto;
            cursor: pointer;
          }
        }
        .right {
          width: 650px;
          height: 675px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .wrapItem {
            width: 315px;
            background-color: #ffffff;
            padding-bottom: 10px;
            margin-bottom: 20px;
          }
        }
      }
      // 拼团
      .combItem {
        display: flex;
        flex-wrap: wrap;
        .comb {
          width: 550px;
          height: 290px;
        }
        .NoInfo {
          display: block;
          width: 100%;
        }
      }
      // 砍价专区
      .bargainBlock {
        display: flex;
        justify-content: space-between;
        img {
          cursor: pointer;
        }
        .left {
          width: 574px;
          height: 574px;
          background-color: #ffffff;
          img {
            width: 100%;
            padding: 49px 115px;
          }
          .des {
            margin: 60px 40px 0;
            color: #666666;
            font-size: 24px;
            font-family: PingFang SC;
            .title {
              display: inline-block;
              width: 312px;
              height: 30px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .pprice {
              float: right;
              text-align: center;
              color: #333333;
              font-size: 30px;
              font-family: PingFang SC;
              font-weight: 500;
              display: flex;
              flex-direction: column;
            }
          }
        }
        .right {
          width: 574px;
          height: 574px;
          // 砍价区右方可抽象内容样式
          .item {
            width: 574px;
            height: 277px;
            padding: 25px 29px;
            background-color: #ffffff;
            display: flex;
            img {
              width: 230px;
              height: 230px;
              margin-right: 58px;
            }
            .itemright {
              margin: 45px 0;
              .title {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-bottom: 40px;
              }
              .pprice {
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
              }
            }
          }
        }
        .prisp {
          font-size: 18px;
          font-weight: 400;
          color: #999999;
          text-decoration: line-through;
        }
      }
      // 秒杀
      .SeckItem {
        .seckillItem {
          display: flex;
          .seckProduct {
            width: 278px;
            margin: 10px;
          }
        }
        .seckillNoInfo {
          width: 100%;
          .NoInfo {
            margin: auto;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/index2.vue